import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "admin-data-table" }
const _hoisted_2 = { class: "admin-table-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "admin-pagination-bar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_spin, { spinning: _ctx.loading }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_table, {
            columns: _ctx.columns,
            "data-source": _ctx.dataSource,
            pagination: false,
            "row-key": _ctx.rowKey,
            "row-selection": _ctx.rowSelection,
            locale: { emptyText: _ctx.emptyText },
            size: "middle",
            bordered: ""
          }, {
            bodyCell: _withCtx((slotProps) => [
              _renderSlot(_ctx.$slots, "bodyCell", _normalizeProps(_guardReactiveProps(slotProps)), undefined, true)
            ]),
            _: 3
          }, 8, ["columns", "data-source", "row-key", "row-selection", "locale"])
        ])
      ]),
      _: 3
    }, 8, ["spinning"]),
    (!_ctx.loading && _ctx.total > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_a_pagination, {
            current: _ctx.paginationCurrent,
            "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paginationCurrent) = $event)),
            "page-size": _ctx.paginationPageSize,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.paginationPageSize) = $event)),
            total: _ctx.total,
            "page-size-options": [20, 50, 100],
            "show-size-changer": "",
            "show-quick-jumper": "",
            "show-total": (total) => `共 ${total} 条`
          }, null, 8, ["current", "page-size", "total", "show-total"])
        ]))
      : _createCommentVNode("", true)
  ]))
}